import SectionHeading from '../shared/SectionHeading'
import styles from './styles.module.scss'

const ServiceSection = (): JSX.Element => (
  <section className={`${styles.block}`} id="about">
    <div className={`${styles.content} ${styles.center}`}>
      <SectionHeading
        eyebrow="ecbo cloakとは"
        title="お店の空きスペースが、コインロッカーになる"
        description="ecbo cloak（エクボクローク）は、荷物を預けたい人と街のお店をつなぐ、荷物預かりのシェアサービスです。カフェや美容室、ホテルの空きスペースが、旅行者の「預け場所」になります。"
      />
      <div className={styles.serviceSteps}>
        <div className={`${styles.serviceStep} ${styles.reveal}`} data-reveal="">
          <img src="/partner-introduction/booking_icon.svg" alt="アプリで予約" />
          <span>STEP 1</span>
          <h3>アプリ・Webで予約</h3>
          <p>行き先の近くの預かりスポットを検索して、事前に予約。</p>
        </div>
        <div className={styles.serviceArrow} aria-hidden="true">
          <img src="/partner-introduction/step_arrow_icon.svg" alt="" />
        </div>
        <div className={`${styles.serviceStep} ${styles.reveal}`} data-reveal="">
          <img src="/partner-introduction/drop_off_icon.svg" alt="お店に預ける" />
          <span>STEP 2</span>
          <h3>お店に預ける</h3>
          <p>当日はお店で荷物を渡すだけ。スーツケース1個から預けられます。</p>
        </div>
        <div className={styles.serviceArrow} aria-hidden="true">
          <img src="/partner-introduction/step_arrow_icon.svg" alt="" />
        </div>
        <div className={`${styles.serviceStep} ${styles.reveal}`} data-reveal="">
          <img src="/partner-introduction/enjoy_icon.svg" alt="手ぶらで観光" />
          <span>STEP 3</span>
          <h3>手ぶらで楽しむ</h3>
          <p>観光もライブも身軽に。営業時間内に受け取ればOK。</p>
        </div>
      </div>
      <p className={`${styles.serviceNote} ${styles.reveal}`} data-reveal="">
        お店側には、スーツケース数個分のスペースで<b>預かり収益</b>と<b>新しい来店</b>
        が生まれます。だから、あなたの紹介はお店にも喜ばれます。
      </p>
    </div>
  </section>
)

export default ServiceSection
